export enum Status {
    Active = 'A',
    Inactive = 'I'
}
